export function nomeRecebedorTemNomeESobrenome(nome: string): boolean {
  const partes = String(nome || "")
    .trim()
    .split(/\s+/)
    .filter((p) => p.length > 0);
  return partes.length >= 2;
}
